module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "el-dropdown-menu-item",
    class: {
      'is-disabled': _vm.disabled,
      'el-dropdown-menu-item-divided': _vm.divided
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4b3009ba!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/src/dropdown-item.vue
// module id = 649
// module chunks = 0